import React from 'react';
import Box from '@mui/system/Box';
type CircleWrapperProps = {
  outerCircleSize?: number;
  innerCircleSize?: number;
  centreColor?: string;
};
export const CircleWrapper: React.FC<React.PropsWithChildren<CircleWrapperProps>> = ({
  children,
  outerCircleSize = 200,
  innerCircleSize = 150,
  centreColor = '#fff',
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: outerCircleSize,
        height: outerCircleSize,
      }}
    >
      {/* Outer Circle */}
      <Box
        sx={{
          position: 'absolute',
          borderRadius: '50%',
          border: `2px solid ${centreColor}`,
          opacity: '0.1',
          width: outerCircleSize,
          height: outerCircleSize,
        }}
      />
      {/* Inner Circle */}
      <Box
        sx={{
          position: 'absolute',
          borderRadius: '50%',
          border: `2px solid ${centreColor}`,
          opacity: '0.3',
          width: innerCircleSize,
          height: innerCircleSize,
        }}
      />
      {/* Children in the center */}
      <Box sx={{ position: 'relative', zIndex: 10 }}>{children}</Box>
    </Box>
  );
};
